module.exports = __webpack_public_path__ + "media/derechovital_b500k.ae849876.webm";